// extracted by mini-css-extract-plugin
export default {"body":"CommentBody_body__+Wn95","mention":"CommentBody_mention__YKEvI","edited":"CommentBody_edited__2umij"};